<template>
  <ul data-animate="list" class="page-news-list__list">
    <li
      v-for="(item, index) in news"
      :key="item.id"
      :class="{ 'm-top-4': index > 0 }"
    >
      <div class="page-news-list__list__item">
        <PagesNewsListBlock :news="item" />
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'PagesNewsList',
}
</script>

<script setup>
const props = defineProps({
  news: Array,
})
</script>
